import {Component, EventEmitter, inject, Input, OnInit, Output, ChangeDetectionStrategy} from '@angular/core';
import {ActivatedRoute, Router} from "@angular/router";
import {StepperComponent} from "../../../util/design/stepper/stepper.component";
import {CdkStep} from "@angular/cdk/stepper";

@Component({
  selector: 'app-hoai-stepper',
  templateUrl: './hoai-stepper.component.html',
  styleUrls: ['./hoai-stepper.component.scss'],

  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    StepperComponent,
    CdkStep
  ]
})
export class HoaiStepperComponent implements OnInit {
  private activatedRoute = inject(ActivatedRoute);
  private router = inject(Router);

  @Input() selectedStep = 0;
  @Output() selectedStepChange = new EventEmitter<number>();

  @Input() isCheckView: boolean = false;
  @Input() nextStepAllowed: boolean = false;
  @Input() previousStepAllowed: boolean = false;
  @Input() linear: boolean = true;

  @Output() changeDrivenEvent = new EventEmitter<number>();

  ngOnInit(): void {

  }

  changeStep(index: number): void {
    this.selectedStep = index;
    this.selectedStepChange.emit(this.selectedStep);
    this.changeDrivenEvent.emit(index);

  }


}
